module.exports = __webpack_public_path__ + "img/footer_icon_pixnet.6ab814a7.svg";